import React, { useMemo } from "react";
import { useAppDispatch, useAppSelector } from "../../../../stores/hook";
import { setDetailInfoId, setPackInfoDetailStatus } from "../GetStartedSlice";
import translations from "../../../../text/get-started-translations.json";
import language from "../../../../utils/LanguageSettings";
import { IPriceOption } from "../../types";
import { Link } from "react-router-dom";
import { OTT, STB } from "../../constants";
import ImageFallback from "../../../../utils/ImageFallback";
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import gfm from 'remark-gfm';
import defaultImgBanner from '../../../../images/icon/default-img-banner.png'
import h1Box from "../../../../images/icon/h1box.png"

interface CardItemProps {
  imgSrc: string;
  title: string;
  campaignParameter: string;
  description: string;
  includes: {
    data: Array<{
      attributes: {
        name: string;
      };
      id: number;
    }>;
  };
  price?: string;
  ott_12Mth_price?: number;
  stb_price?: number;
  stb_12Mth_price?: number;
  ottPriceDetail: string;
  stbPriceDetail: string;
  ottCampaign: string;
  stbCampaign?: string;
  stb_12M_campaign?: string;
  box_detail_id?: string;
  Tagline?: string;
  PriceOptions?: Array<IPriceOption>;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  featured?: boolean;
  imgSrcFeat?: string;
}

const CardItem: React.FC<CardItemProps> = (props) => {
  const pageTranslations = translations[language]; // Select the correct translations
  const {
    imgSrc,
    title,
    campaignParameter,
    featured,
    imgSrcFeat,
    description,
    includes,
    ottPriceDetail,
    stbPriceDetail,
    ott_12Mth_price,
    stb_12Mth_price,
    price,
    stb_price,
    ottCampaign,
    stbCampaign,
    stb_12M_campaign,
    Tagline,
    onClick,
    box_detail_id,
    PriceOptions,
  } = props;
  const COMBO_PACK_PREFIX = "/combo-pack";
  const isTvBoxPage = useAppSelector((state) => state.getStarted.isTvBoxPage);
  const isRecommendationPage = useAppSelector(
    (state) => state.getStarted.isRecommendationPage
  );
  const priceDetail =
    isTvBoxPage || isRecommendationPage ? stbPriceDetail : ottPriceDetail;
  // const filteredPriceOptions = useMemo(() => {
  //   const tmpFilteredPriceOptions = [] as IPriceOption[];
  //   if (PriceOptions && PriceOptions.length > 0) {
  //     if (isTvBoxPage) {
  //       PriceOptions.forEach((priceOption) => {
  //         if (priceOption.Platform === STB) {
  //           tmpFilteredPriceOptions.push(priceOption);
  //         }
  //       });
  //     } else {
  //       PriceOptions.forEach((priceOption) => {
  //         if (priceOption.Platform === OTT) {
  //           tmpFilteredPriceOptions.push(priceOption);
  //         }
  //       });
  //     }
  //   }
  //   return tmpFilteredPriceOptions;
  // }, [PriceOptions, isTvBoxPage]);

  const buttonText = useMemo(() => {
    return PriceOptions && PriceOptions.length > 1
      ? pageTranslations.SeeOptions
      : pageTranslations.SubscribeNow;
  }, [PriceOptions]);

  const priceOption = useMemo(() => {
    if (PriceOptions && PriceOptions.length === 1) {
      let priceOption = {
        priceText: "",
        priceDetail: "",
      };
      switch (PriceOptions[0].Type) {
        case "Yearly":
          priceOption.priceText = `${
            isTvBoxPage || isRecommendationPage
              ? ""
              : "<span>" + pageTranslations.Avg + "</span>"
          } $${(PriceOptions[0].Price / 12).toLocaleString("zh-HK")}<span> / ${
            pageTranslations.Month
          }</span>`;
          priceOption.priceDetail = isTvBoxPage
            ? pageTranslations["12MthsCommitment"]
            : isRecommendationPage
            ? pageTranslations["12MthsCommitment2"]
            : `${pageTranslations.BilledAs}$${PriceOptions[0].Price}${pageTranslations.Every12Mths}<br/>${pageTranslations.Instant}`;
          break;
        case "Monthly":
          priceOption.priceText =
            "$" +
            PriceOptions[0].Price +
            "<span> / " +
            pageTranslations.Month +
            "</span>";
          priceOption.priceDetail = isTvBoxPage
            ? pageTranslations["12MthsCommitment"]
            : isRecommendationPage
            ? pageTranslations["12MthsCommitment2"]
            : pageTranslations.Instant;
          break;
        case "Daily":
          priceOption.priceText =
            "$" +
            PriceOptions[0].Price +
            "<span> / " +
            pageTranslations.day +
            "</span>";
          console.log("daily, price: ", priceOption.priceText);
          priceOption.priceDetail = pageTranslations.Instant;
          break;
        case "Event":
          priceOption.priceText =
            "$" +
            PriceOptions[0].Price +
            "<span> / " +
            pageTranslations.EventPass +
            "</span>";
          priceOption.priceDetail = pageTranslations.Instant;
          break;
      }
      return priceOption;
    } else if (PriceOptions && PriceOptions.length > 1) {
      const priceDetail = isTvBoxPage
        ? pageTranslations["12MthsCommitment"]
        : isRecommendationPage
        ? pageTranslations["12MthsCommitment2"]
        : pageTranslations.Instant;
      let priceOption = {
        priceText: "",
        priceDetail: priceDetail,
      };
      switch (PriceOptions[0].Type) {
        case "Yearly":
          priceOption.priceText = `<span>${pageTranslations.From}</span> $${(
            PriceOptions[0].Price / 12
          ).toLocaleString("zh-HK")}<span> / ${
            pageTranslations.MonthThen
          }</span>`;
          break;
        case "Monthly":
          priceOption.priceText = `<span>${pageTranslations.From}</span> $${PriceOptions[0].Price}<span> / ${pageTranslations.MonthThen}</span>`;
          break;
        case "Daily":
          priceOption.priceText = `$${PriceOptions[0].Price}<span> / ${pageTranslations.day}</span>`;
          priceOption.priceDetail = pageTranslations.Instant;
          break;
        case "Event":
          priceOption.priceText = `$${PriceOptions[0].Price}<span> / ${pageTranslations.EventPass}</span>`;
          priceOption.priceDetail = pageTranslations.Instant;
          break;
      }
      return priceOption;
    }
    return {
      priceText: "",
      priceDetail: "",
    };
  }, [PriceOptions]);

  const dispatch = useAppDispatch();

  const handleClick = (id: string) => {
    dispatch(setDetailInfoId(id));
    dispatch(setPackInfoDetailStatus(true));
  };

  const imgSrcToUse = featured ? imgSrcFeat : imgSrc;

  return (
    <div className={`item ${featured ? "featured" : ""}`} data-campaign={campaignParameter?.toLowerCase().replace(/\s+/g, '-')}>
      <div className="card">
        <div className="card-img">
          <ImageFallback
            primarySrc={imgSrcToUse}
            defaultSrc={defaultImgBanner}
          />
        </div>
        <div className="details">
          <div className="top">
            {isTvBoxPage && (
              <>
                <div className={`stb-heading`}>
                  <div className={`heading-plusbox`}>
                    <h3>{title}</h3>
                    <h4>+ {pageTranslations.TopBox}</h4>
                  </div>
                  <img
                    src={h1Box}
                    alt="H1 Box"
                  ></img>
                </div>
                <div className="desc">
                  <ReactMarkdown remarkPlugins={[gfm]} rehypePlugins={[rehypeRaw]}>{description}</ReactMarkdown>
                </div>
              </>
            )}
            {!isTvBoxPage && (
              <>
                <h3>{title}</h3>
                <div className="desc">
                  <ReactMarkdown remarkPlugins={[gfm]} rehypePlugins={[rehypeRaw]}>{description}</ReactMarkdown>
                </div>
              </>
            )}
          </div>

          <div className="includes">
            <h5>{pageTranslations.PlanIncludes}</h5>
            <ul>
              {isTvBoxPage && (
                <li>
                  <span className="h1box">{pageTranslations.TopBox}</span>
                </li>
              )}
              {Array.isArray(includes?.data) && includes?.data?.length > 0
                ? includes?.data?.map((include, index) => (
                    <li key={index}>
                      <a
                        onClick={() => handleClick(include.id.toString())}
                        className="show-pack"
                        data-pack-name={include.attributes.name}
                      >
                        {include.attributes.name}
                      </a>
                    </li>
                  ))
                : (!isTvBoxPage || !isRecommendationPage) && (
                    <li>{pageTranslations.NoIncludes}</li>
                  )}
            </ul>
          </div>

          <div className="bottom-control">
            <div className="price-wrap">
              {
                <h3 className="price">
                  <div>
                    <ReactMarkdown remarkPlugins={[gfm]} rehypePlugins={[rehypeRaw]} components={{p: React.Fragment,}}>{priceOption.priceText + (isRecommendationPage ? "<span style='font-size:20px'> *</span>" : "")}</ReactMarkdown>
                  </div>
                </h3>
              }
                <small>
                  <ReactMarkdown remarkPlugins={[gfm]} rehypePlugins={[rehypeRaw]} components={{p: React.Fragment,}}>{Tagline || ""}</ReactMarkdown>
                </small>
            </div>

            <div className="cta-buttons">
              <button
                onClick={onClick}
                className="btn primary subscribe-now"
                ott-campaign={ottCampaign}
              >
                {buttonText}
              </button>
              {(isTvBoxPage || isRecommendationPage) && box_detail_id && (
                <Link
                  to={`${COMBO_PACK_PREFIX}/${box_detail_id}`}
                  className="link arrow"
                >
                  {pageTranslations.LearnMore}
                </Link>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardItem;
